module.exports = __webpack_public_path__ + "static/media/053-ghana.c747a45b.svg";